/* TODO: Remove in next releas 6.1.1 */
import { ActionCard, ActionCardItemRenderProps } from '@graphcommerce/next-ui'
import { ConfigurableOptionValueTextFragment } from '@graphcommerce/magento-product-configurable/components/ConfigurableOptionValueText/ConfigurableOptionValueText.gql'
import {lighten} from '@mui/material'

export type ConfigurableOptionValueTextProps =
  ActionCardItemRenderProps<ConfigurableOptionValueTextFragment>

export function ConfigurableOptionValueText(props: ConfigurableOptionValueTextProps) {
  const { swatch_data, store_label, uid, use_default_value, size, ...actionCardProps } = props

  if (swatch_data && swatch_data?.__typename !== 'TextSwatchData')
    throw Error(`ConfigurableOptionValueText can not render a ${swatch_data?.__typename}`)

  const title = swatch_data?.value ?? store_label
  const details = size !== 'small' && swatch_data?.value ? store_label : undefined

  return <ActionCard {...actionCardProps}
                     size={size}
                     title={title}
                     details={details}
                     sx={(theme) => ({
                       border: `1px solid ${theme.palette.text.secondary}`,
                       borderColor: theme.palette.text.secondary,
                       borderRadius: '0  !important',
                       '&.selected': {
                         border: `1px solid ${theme.palette.primary.main}`,
                         borderColor: `${theme.palette.primary.main} !important`,
                         backgroundColor: lighten(theme.palette.primary.main, 0.9)
                       }
                     })}
  />
}
